class TimeHelper {
  toDateString = string => {
    if(string === "" || string == undefined ) return "";
    let date = new Date(string);
    return date.toDateString();
  }
}

export default new TimeHelper();


// WEBPACK FOOTER //
// ./src/utils/TimeHelper.js